import React, { Component } from "react";
import { Helmet } from "react-helmet";

import mobiledownload from "./file/PrivacySaferIIV3.1.crx";
import desktopdownload from "./file/PrivacySaferIIV3.1.rar";

class About extends Component {

    render() {

        let pageTitle = this.props.lang == 'en' ? "About" : "Σχετικα";
        let downloadDesktopText = this.props.lang == 'en' ? "Free Download for desktop! " : "Κατεβάστε τώρα για υπολογιστή!"
        let downloadMobileText = this.props.lang == 'en' ? "Free Download for mobile!" : "Κατεβάστε τώρα για κινητά!"
        let aboutTextPartOne = this.props.lang == 'en' ? "PrivacySaferII is a web extension that is implemented under the CyberSafety project. Its target audience is high school students, their parents, and guardians."
            : "Το PrivacySaferII είναι μια επέκταση ιστού που υλοποιείται στο πλαίσιο του έργου CyberSafety. Η εφαρμογή αφορά μαθητές γυμνασίου, γονείς και κηδεμόνες."

        let aboutTextPartTwo = this.props.lang == 'en' ? "You can use PrivacySaferII to limit the collection of sensitive and personal data from various web applications based on your preferences and choices. The extension can protect the privacy of each child from the potential dangers regarding access to personal data."
            : "Μπορείτε να χρησιμοποιήσετε το PrivacySaferII για να περιορίσετε τη συλλογή ευαίσθητων και προσωπικών δεδομένων από διάφορες εφαρμογές ιστού με βάση τις προτιμήσεις και τις επιλογές σας. Η επέκταση μπορεί να προστατεύσει το απόρρητο κάθε παιδιού από τους πιθανούς κινδύνους που σχετίζονται με την πρόσβαση σε προσωπικά δεδομένα"


        return (

            <section className="page-section" id="about">
                <Helmet>
                    <meta charset="utf-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                    <meta name="description" content="" />
                    <meta name="author" content="" />
                    <title>PrivacySaferIII</title>

                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
                    <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
                    <script src="https://use.fontawesome.com/releases/v5.12.1/js/all.js" crossorigin="anonymous"></script>


                    <link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css" />
                    <link href="https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic" rel="stylesheet"
                        type="text/css" />
                </Helmet>

                <div className="container">

                    <h2 className="page-section-heading text-center text-uppercase"><label className="lang"
                        key="aboutTitle">{pageTitle}</label></h2>

                    <div className="divider-custom">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon"><i className="fas fa-star"></i></div>
                        <div className="divider-custom-line"></div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 ml-auto">
                            <p className="lead">
                                <label className="lang" key="abouTextPartOne">
                                    {aboutTextPartOne}
                                </label>
                            </p>

                        </div>
                        <div className="col-lg-4 mr-auto">
                            <p className="lead">
                                <label className="lang" key="aboutTextPartTwo">
                                    {aboutTextPartTwo}
                                </label>
                            </p>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 ml-auto">
                            <a className="btn btn-xl btn-outline-dark" href={desktopdownload} download><i
                                className="fas fa-download mr-2"></i><label className="lang" key="downloadDesktop"> {downloadDesktopText}</label> </a>
                        </div>
                        <div className="col-lg-4 mr-auto">
                            <a className="btn btn-xl btn-outline-dark" href={mobiledownload} download><i
                                className="fas fa-download mr-2"></i><label className="lang" key="downloadMobile"> {downloadMobileText} </label> </a>
                        </div>
                    </div>
                </div>
            </section >
        );
    }
}

export default About;